import type {
  Currencies,
  CurrenciesApi,
  Currency,
  CurrencyApi,
  CurrencyFilters,
  CurrencyFiltersUpdateApi,
} from '../../models';
import { inlineSearch, paginate } from '../normalize';

export const normalizeCurrency = (currency: CurrencyApi): Currency => ({
  ...currency,
  label: currency.currencyName,
});

export const normalizeCurrencies = (response: CurrenciesApi): Currencies => {
  const list = (response.items ?? [])
    .sort((a, b) => a.currencyName.localeCompare(b.currencyName))
    .map(normalizeCurrency);
  return {
    list,
    map: list.reduce(
      (acc, currency) => {
        acc[String(currency.id)] = currency;
        return acc;
      },
      {} as Currencies['map'],
    ),
  };
};

export const normalizeCurrencyFilters = (filters: Partial<CurrencyFilters>): CurrencyFiltersUpdateApi => {
  const { search, ...otherFilters } = filters;
  return {
    ...inlineSearch(search),
    ...inlineSearch(otherFilters),
    ...paginate(otherFilters),
    Sorting: 'currencyName asc',
  };
};
